import { render, staticRenderFns } from "./add-to-cart.vue?vue&type=template&id=4091e2e0&"
import script from "./add-to-cart.vue?vue&type=script&lang=js&"
export * from "./add-to-cart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('4091e2e0', component.options)
    } else {
      api.reload('4091e2e0', component.options)
    }
    module.hot.accept("./add-to-cart.vue?vue&type=template&id=4091e2e0&", function () {
      api.rerender('4091e2e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/assets/js/components/add-to-cart.vue"
export default component.exports